export interface Transformation {
  id: string
  before: string
  after: string
  title: { en: string; es: string }
  vehicle: { en: string; es: string }
  alt: { en: string; es: string }
}

export const transformations: Transformation[] = [
  {
    id: 'f150-front-cabin',
    before: 'https://cdn.magicpatterns.com/uploads/waTmBrNr9tacYpecbkVd2G/Antes1.jpg',
    after: 'https://cdn.magicpatterns.com/uploads/1Nr3evnqmtEbTPqGSWzFuD/Despues1.jpg',
    title: { en: 'Front cabin & floor mat reset', es: 'Cabina delantera y tapetes como nuevos' },
    vehicle: { en: 'Ford F-150 · Complete detail', es: 'Ford F-150 · Detallado completo' },
    alt: {
      en: 'Ford F-150 front cabin before and after: dusty seat and dirty floor mat restored to clean upholstery and spotless mat',
      es: 'Cabina delantera de Ford F-150 antes y después: asiento y tapete sucios restaurados a tapicería limpia y tapete impecable',
    },
  },
  {
    id: 'sedan-exterior',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/d14bf921-5162-4682-9143-49b680f8853b.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/e5e0d6e0-b82d-414d-9395-7339358f064c.jpg',
    title: { en: 'Deep exterior wash & polish', es: 'Lavado profundo y pulido exterior' },
    vehicle: { en: 'Sedan · Basic package', es: 'Sedán · Paquete básico' },
    alt: {
      en: 'Grey sedan before and after a deep exterior wash and polish',
      es: 'Sedán gris antes y después de un lavado exterior profundo y pulido',
    },
  },
  {
    id: 'truck-exterior',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/14c25b54-719e-4f19-bafc-8aacfe70cab7.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/abe0ceaf-35f1-4ce5-bca4-c7da3380c710.jpg',
    title: { en: 'Mud removal & paint restore', es: 'Remoción de lodo y restauración de pintura' },
    vehicle: { en: 'Pickup truck · Basic package', es: 'Camioneta · Paquete básico' },
    alt: {
      en: 'White pickup truck before and after mud removal and paint restoration',
      es: 'Camioneta blanca antes y después de la remoción de lodo y restauración de pintura',
    },
  },
]

/**
 * "Wash In Action" media. Add videos as { type: 'video', src: '...mp4', poster: '...jpg' }.
 * Photo entries open in the same lightbox.
 */
export interface ActionMedia {
  id: string
  type: 'video' | 'photo'
  src: string
  poster: string
  title: { en: string; es: string }
  description: { en: string; es: string }
}

export const actionMedia: ActionMedia[] = [
  {
    id: 'tundra-side',
    type: 'photo',
    src: 'https://cdn.magicpatterns.com/uploads/4WiUUGYntVZDC2yHNiXMS9/Img1.jpg',
    poster: 'https://cdn.magicpatterns.com/uploads/4WiUUGYntVZDC2yHNiXMS9/Img1.jpg',
    title: { en: 'Exterior foam wash', es: 'Lavado exterior con espuma' },
    description: {
      en: 'Toyota Tundra Platinum, rinsed and foamed on site.',
      es: 'Toyota Tundra Platinum, enjuagada y con espuma a domicilio.',
    },
  },
  {
    id: 'tundra-wheel',
    type: 'photo',
    src: 'https://cdn.magicpatterns.com/uploads/4m7CVupvpdiLksNz3guLrp/Img2.jpg',
    poster: 'https://cdn.magicpatterns.com/uploads/4m7CVupvpdiLksNz3guLrp/Img2.jpg',
    title: { en: 'Wheel & tire detail', es: 'Detallado de rines y llantas' },
    description: {
      en: 'Wheel faces, barrels and wells cleaned, then tire shine.',
      es: 'Rines, interior del rin y salpicaderas limpios, luego brillo de llanta.',
    },
  },
  {
    id: 'tundra-grille',
    type: 'photo',
    src: 'https://cdn.magicpatterns.com/uploads/avVMto21bumWHDEXPGHBpD/Img3.jpg',
    poster: 'https://cdn.magicpatterns.com/uploads/avVMto21bumWHDEXPGHBpD/Img3.jpg',
    title: { en: 'Chrome grille finish', es: 'Acabado de parrilla cromada' },
    description: {
      en: 'Every chrome slat hand-wiped for a streak-free shine.',
      es: 'Cada barra cromada limpiada a mano para un brillo sin marcas.',
    },
  },
]

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/u6GqTPGtt1WoFH8D2MW8Xo/Banner_Los_brothers.png'

export const teamImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/c80f8d8f-6dfa-425f-9041-d7979df1fae4.jpg'

export const instagramTiles = [
  actionMedia[0].poster,
  transformations[0].after,
  actionMedia[1].poster,
  transformations[2].after,
  actionMedia[2].poster,
  teamImage,
  transformations[1].after,
  transformations[0].before,
  transformations[2].before,
]
